export default __webpack_public_path__ + "static/media/8.b8e2b04d.png";